export enum NotificationBarType {
    Error = 0,
    Success = 1,
}
